import { inject } from '@angular/core';
import {
  CanMatchFn,
  UrlSegmentGroup,
  defaultUrlMatcher
} from '@angular/router';
import { map } from 'rxjs';
import { CardViewService } from './card-view.service';

export const dynamicSectionCanMatchGuard: CanMatchFn = (route, segments) => {
  const cardViewService = inject(CardViewService);
  return cardViewService.getViews('section').pipe(
    map((views) =>
      views.some((view) => {
        const segmentGroup = new UrlSegmentGroup(segments, {});
        const res = defaultUrlMatcher(segments, segmentGroup, {
          path: view.Path
        });
        return !!res;
      })
    )
  );
};
